import { Injectable } from '@angular/core';
import { ApiService } from '../../services/http/api.service';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserProfileService {
  loaded = new Subject<boolean>();
  merchant: any = {};
  customers: any[] = [];
  accounts: any[] = [];
  orders: any[] = [];
  business: any = {};

  constructor(
    private api: ApiService
  ) { }

  loadMerchantProfile() {
    this.api.getData('/seller/profile').subscribe({
      next: (res: any) => {
        this.merchant = res;
        let merchant_business = this.merchant.businesses;

        if (merchant_business.length > 0) {
          this.business = this.merchant.businesses[0];
          this.customers = this.business.customers;
          this.accounts = this.business.accounts;
          this.orders = this.business.orders;
        }

        this.loaded.next(true);
      },
      error: (err: any) => {
        this.loaded.next(false);
      }
    })
  }

  loadReligions() {
    return this.api.getData('/religions');
  }

  loadRaces() {
    return this.api.getData('/races');
  }

  loadDistricts() {
    return this.api.getData('/districts');
  }

  createBusiness(payload: any) {
    return this.api.createBusiness(payload);
  }

  updateCurrentMerchant(payload: any) {
    return this.api.updateCurrentUser(payload);
  }

  updateEmail(payload: any) {
    return this.api.changeEmail(payload);
  }
}